import React, { Component } from 'react';
import { connect } from 'react-redux';

import AppBar from '@material-ui/core/AppBar';
import ArrowBack from '@material-ui/icons/ArrowBack';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';

import { appSetRoute } from '../../store/actions';

const styles = theme => ({
  appBar: {
    height: '48px',
    paddingTop: '2px'
  },
  backDiv: {
    position:'absolute',
    paddingLeft: '-5px',
    paddingTop: '5px',
  },
  back: {
    color:'white',
    fontSize:'2.5em'
  },
  info: {
    width:'100%',
    textAlign: 'center',
    color: 'white',
    fontSize: '1em',
    '& > span':{
      marginRight: '5px'
    }
  },
  title: {
    color:'white',
    fontSize:'1.4em',
    marginRight:'10px',
    textAlign: 'center',
    width:'100%'
  },
  root: {
    position:'fixed',
    top: '0px',
    width:'100%'
    // zIndex: '1'
  }
});

class Header extends Component{
  constructor(props){
     super(props);

     this._backClick = this._backClick.bind(this);
  }

  _backClick = ()=>{
    this.props.appSetRoute(this.props.backPage);    
  }
  
  render(){
    const { classes } = this.props;

    let profileInfo = ()=>{
      if (this.props.user){
        return this.props.user + ',' + this.props.branch;
      } else {
        return '';
      }
    }

    return (
      <div className={classes.root}>           
          <AppBar>
            {this.props.back && 
              <div className={classes.backDiv} onClick={this._backClick}>
                <ArrowBack className={classes.back} />
              </div>}
            <div className={classes.appBar}>
              <div>
                <span className={classes.title}>SSMS-360</span>
                <span className={classes.info}>
                  {this.props.version}
                </span>
              </div>
              <div className={classes.info}>
                  {profileInfo()} {this.props.plate}
              </div>
            </div>
            { this.props.appState===2 &&
              <LinearProgress className={classes.linearProgress}
                mode="indeterminate"
              />
            }
          </AppBar>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
      backPage: state.app.backPage
  }
}

const mapDispatchToProps = dispatch => {
  return {
      appSetRoute: (route) => dispatch(appSetRoute(route))
  }
}  

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Header));


// WEBPACK FOOTER //
// ./src/components/Header/index.js